import {
    FETCH_CREATE_WASTE_REQUEST,
    FETCH_CREATE_WASTE_SUCCESS,
    FETCH_CREATE_WASTE_FALUIRE,
} from './createWasteType'

const initialState = {
    loading: false,
    isCreateWasteSuccess: null,
    error: '',
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CREATE_WASTE_REQUEST: return {
            ...state,
            loading: true,
            error: '',

        }

        case FETCH_CREATE_WASTE_SUCCESS: return {
            ...state,
            isCreateWasteSuccess: action.payload,
            error: '',
            loading: false,
        }

        case FETCH_CREATE_WASTE_FALUIRE: return {
            ...state,
            loading: false,
            isCreateWasteSuccess: null,
            error: action.payload,
        }
        default: return state
    }
}

export default reducer
